import { render } from "./Store.vue?vue&type=template&id=5bcc6d85&scoped=true"
import script from "./Store.vue?vue&type=script&lang=js"
export * from "./Store.vue?vue&type=script&lang=js"

import "./Store.vue?vue&type=style&index=0&id=5bcc6d85&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5bcc6d85"

export default script